if (!customElements.get('cart-drawer-promotions-form')) {
  customElements.define('cart-drawer-promotions-form', class CartDrawerPromotionsForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {

      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('free')
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {

        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            document.querySelector('.ajax-add-notice').classList.add('hidden')

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);

            this.error = true;
            return;
          } else if (!this.cart) {
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            document.querySelector('.ajax-add-notice').classList.remove('hidden')
          }

          this.udpateItemsCountAfterAddToCart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {

          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');


        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (errorMessage.email) {
          this.emailErrorMessage = this.querySelector('.recipient-form__email-error-message-wrapper .product-form__error-message');
          if (!this.emailErrorMessage) return;
          this.emailErrorMessage.parentNode.toggleAttribute('hidden', !errorMessage);
          this.emailErrorMessage.textContent = errorMessage.email;
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
    udpateItemsCountAfterAddToCart() {
      fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: {'Accept': `application/javascript`, 'X-Requested-With':`XMLHttpRequest`}
      })
        .then((response) => response.json())
        .then((cart) => {
          cartItemCount(cart.item_count);
        })
    }
  });
}

class CartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-products') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  
  customElements.define('remove-item', CartRemoveButton);


  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
        
      }, 300);
 
      this.addEventListener('change', this.debouncedOnChange.bind(this));
      
   
    }
  
    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  
    getSectionsToRender() {
    
      return [
        {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
        },
        {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.cart-total-text',
        }
      ];
    }
  
    updateQuantity(line, quantity, name) {
      this.enableLoading(line);
   
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
         
          //item_count
          if (typeof parsedState.item_count === 'undefined') {
            cartItemCount(0);
          } else {
            cartItemCount(parsedState.item_count);
          }

          drawerFreeDelveryLine(parsedState.total_price);
         
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          // promotion products slider init
          if (typeof window.recreatePromotionProductsSlider === "function") {
            recreatePromotionProductsSlider();
          }

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }

          this.disableLoading();
        })
        
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          this.disableLoading();
        });
    }
  
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        lineItemError
          .querySelector('.cart-item-error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );
      }

      this.currentItemCount = itemCount;

      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items');
   
      const cartItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
     
    }
  
    disableLoading() {
      const mainCartItems = document.getElementById('main-cart-items');
     
    }
  }
  
  customElements.define('cart-products', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          // fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });

          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((cart) => {
              cartItemCount(cart.item_count);
              //delivery line count
              drawerFreeDelveryLine(cart.total_price)
            })
        }, 300))
      }
    });
  };
 
/*********************************************************** */
/********************** advanced js***************************/
/*********************************************************** */
//cart item count
function cartItemCount(item_count) {
  let cartCount = document.querySelectorAll('.cart-counter');
  cartCount.forEach(item => {
    item.innerHTML = item_count;
  });
  updateFreeShippingCartCounts(item_count);
}

function updateFreeShippingCartCounts(itemCount) {
  document.querySelectorAll('.cart-freeshipping-line[data-cart-count-text-one]').forEach((item) => {
    const labelEl = item.querySelector('.cart-freeshipping-line__cart-count-label');
    if (!labelEl) return;

    const count = Number(itemCount);
    const template = count === 1
      ? (item.dataset.cartCountTextOne || '[count] item in cart')
      : (item.dataset.cartCountTextOther || '[count] items in cart');
    labelEl.textContent = template.replace('[count]', count);
    labelEl.hidden = false;
    labelEl.setAttribute('aria-hidden', 'false');
  });
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
if(typeof currencyIso_code !== 'undefined'){
  if(currencyIso_code == ''){
      currencyIso_code = '$'
  }
}else{
    var currencyIso_code = '$'
}

Shopify.money_format = '{{amount}}';
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


//Multi-tier free shipping / free gift progress bar (PDP / PLP)
function updateTieredFreeShippingLine(item, totalPrice){
  let tiers;
  try {
    tiers = JSON.parse(item.dataset.tiers || '[]');
  } catch (e) {
    return;
  }
  if (!tiers.length) return;

  let currentTotal = Number(Shopify.formatMoney(totalPrice, Shopify.money_format).replace(/\,/g,''));
  let maxAmount = tiers[tiers.length - 1].amount;
  let nextTier = tiers.find((tier) => currentTotal < tier.amount);

  const messageEl = item.querySelector('.cart-freeshipping-message');
  const indicatorLineEl = item.querySelector('.cart-freeshipping-indicator-line');

  if (!nextTier) {
    indicatorLineEl.style.left = '0';
    item.classList.add('free-get');
    if (messageEl) messageEl.innerHTML = item.dataset.doneText || '';
  } else {
    let leaveMoney = parseFloat((nextTier.amount - currentTotal).toFixed(4));
    let percentleave = currentTotal * 100 / maxAmount;
    indicatorLineEl.style.left = (percentleave - 100) + '%';
    item.classList.remove('free-get');
    if (messageEl) {
      messageEl.innerHTML = `${item.dataset.beforeText || ''} ${currencyIso_code}${leaveMoney} ${nextTier.text}`;
    }
  }
}

//Free delivery price count
function drawerFreeDelveryLine(totalPrice){

  if(document.querySelectorAll('.cart-freeshipping-line').length > 0){

    document.querySelectorAll('.cart-freeshipping-line').forEach((item)=>{
      if(item.dataset.tiers){
        updateTieredFreeShippingLine(item, totalPrice);
        return;
      }
      if(item.dataset.shipping){
        let currentTotal = Shopify.formatMoney(totalPrice, Shopify.money_format).replace(/\,/g,'');
        let freeMoneyDelivery = Number(item.dataset.shipping); 

        let leaveMoney = 0;
        let percentleave = 0; 
      
        if(currentTotal < freeMoneyDelivery){
            leaveMoney = freeMoneyDelivery - Number(currentTotal);
            leaveMoney = parseFloat(leaveMoney.toFixed(4))
            percentleave = Number(currentTotal) * 100 / freeMoneyDelivery;
            item.querySelector('.cart-freeshipping-indicator-line').style.left = percentleave-100+'%'
            item.classList.remove('free-get');


        }else{
          item.querySelector('.cart-freeshipping-indicator-line').style.left = '0';
          item.classList.add('free-get');
          
        }
        item.querySelector('.cart-freeshipping-price').innerHTML = currencyIso_code+''+leaveMoney;

      }
    })
  }
}
//first load page show shiping
function fetchCart() {
  fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {'Accept': `application/javascript`, 'X-Requested-With':`XMLHttpRequest`}
  })
  .then((response) => response.json())
  .then((cart) => {
      drawerFreeDelveryLine(cart.total_price);
      updateFreeShippingCartCounts(cart.item_count);
  })
}
fetchCart();

// Rebuy Smart Cart handles remove/qty changes outside theme cart.js
document.addEventListener('rebuy:cart.change', (event) => {
  const shopifyCart = event.detail?.cart?.cart;
  if (!shopifyCart) return;
  drawerFreeDelveryLine(shopifyCart.total_price);
  updateFreeShippingCartCounts(shopifyCart.item_count);
});